import { useCallback, useState } from 'react';
import { useTracesSSE } from './useTracesSSE';

export function useTracesListRefresh({
  applicationId,
  invalidateTotalCount,
  invalidateApplicationDomainTree,
}: {
  applicationId: string | undefined;
  invalidateTotalCount: () => Promise<unknown> | void;
  invalidateApplicationDomainTree: (params: {
    applicationId: string;
  }) => Promise<unknown> | void;
}) {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [silentRefreshKey, setSilentRefreshKey] = useState(0);

  const triggerSilentRefresh = useCallback(() => {
    setSilentRefreshKey((previous) => previous + 1);
    void invalidateTotalCount();
  }, [invalidateTotalCount]);

  const handleRefresh = useCallback(() => {
    setIsRefreshing(true);
    triggerSilentRefresh();

    if (applicationId) {
      void invalidateApplicationDomainTree({ applicationId });
    }

    setTimeout(() => setIsRefreshing(false), 500);
  }, [applicationId, invalidateApplicationDomainTree, triggerSilentRefresh]);

  useTracesSSE({
    applicationId: applicationId || '',
    enabled: !!applicationId,
    onTraceUpdate: triggerSilentRefresh,
  });

  return {
    isRefreshing,
    silentRefreshKey,
    handleRefresh,
  };
}
